import styled from "styled-components";

export const FooterDiv = styled.div`
    padding-top: 2rem;
    background: var(--pallet-1);
`

export const HorizontalLineDiv = styled.div`
    border-top: 3px solid var(--pallet-4);
    width: 100%;
    color: 
`


export const ContentDiv = styled.div`
    padding: 1.5em 0;
    text-align: center;
    color: var(--pallet-4)
`
